/** Browser timezone must not change a Norwegian operational plan. */
// Reuse the formatter when projecting hundreds of stops in the timeline.
const osloFormatter = new Intl.DateTimeFormat("sv-SE", {
  timeZone: "Europe/Oslo",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  hourCycle: "h23",
});

export const osloDateTimeInput = (value?: string | null): string => {
  if (!value) return "";
  if (!/(Z|[+-]\d\d:\d\d)$/.test(value)) return value.slice(0, 16);
  const parts = osloFormatter.formatToParts(new Date(value));
  const part = (type: string) =>
    parts.find((item) => item.type === type)?.value;
  return `${part("year")}-${part("month")}-${part("day")}T${part("hour")}:${part("minute")}`;
};
